import styles from './MainReviewFrame.module.scss';
import star from '../../assets/star.png';
import emptyStar from '../../assets/emptyStar.png';
import { IReviewDataType } from '../../pages/MyReview/MyReview';

function MainReviewFrame(props: { review: IReviewDataType }) {
  const calculateStarCount = () => {
    return Math.round(
      (props.review.stars0 +
        props.review.stars1 +
        props.review.stars2 +
        props.review.stars3) /
        4 /
        20,
    );
  };
  
  return (
    <div className={styles.container}>
      <div className={styles.reviewImageWrap}>
        <img
          src={
            props.review.images[0]
              ? props.review.images[0].image + '?w=400'
              : props.review.product.list_image + '?w=400'
          }
          alt="reviewImg"
        />
      </div>
      <div className={styles.reviewInfoWrap}>
        <div className={styles.reviewContent}>{props.review.content}</div>
        <div className={styles.divider}></div>
        <div className={styles.reviewInfoBottom}>
          <img
            src={
              props.review.product.list_image
                ? props.review.product.list_image + '?w=100'
                : '/path/to/default-image.png'
            }
            alt="productThumbnail"
            className={styles.thumbnail}
          />
          <div className={styles.userInfoWrap}>
            <div className={styles.userInfoDetails}>
              <span className={styles.userId}>{props.review.member_id}</span>
              <span className={styles.userInfo}>
                {props.review.age}대 / {props.review.gender === 'F' ? '여성' : '남성'}
                {props.review.weight > 0 && ` / ${props.review.weight}KG`}
              </span>
            </div>
            <div className={styles.reviewScore}>
              <img src={star} alt="star" className={styles.starIcon} />
              <span>({calculateStarCount()})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainReviewFrame;
